import { registerPlugin } from '@capacitor/core';
const wifi = registerPlugin('wifi', {
  web: () => import('./web').then(m => new m.wifiWeb()),
});
export * from './definitions';
export { wifi };
